import React from 'react';

export default ({item, label}) => (
  <div className="targetinfo">
    { item.agemin > 0 &&
     <span className="targetinfo_age">
     { label &&  <span>{label}: </span> }
     <span>{item.agemin} </span>
     { item.agemax > 0 &&
       <span> - {item.agemax} </span>
     }
     <span>år</span>
     </span>
    }
  </div>

);



// WEBPACK FOOTER //
// ./src/components/Formaters/AgeInfo.jsx